import * as types from 'misc/types';
import * as actions from 'misc/actions';

const envelope = (state = actions.initial(), action) => {
    switch (action.type) {
        case types.SAGA_ENVELOPE_ARCHIVE.REQUEST:
            return actions.load(state);
        case types.SAGA_ENVELOPE_ARCHIVE.SUCCESS:
            return actions.save(state, action.payload);
        case types.SAGA_ENVELOPE_ARCHIVE.FAILURE:
            return actions.error(state, action.error);

        case types.SAGA_ENVELOPE_DELETE.REQUEST:
            return actions.load(state);
        case types.SAGA_ENVELOPE_DELETE.SUCCESS:
            return actions.save(state, action.payload);
        case types.SAGA_ENVELOPE_DELETE.FAILURE:
            return actions.error(state, action.error);

        default:
            return state;
    }
};

export default envelope;



// WEBPACK FOOTER //
// ./src/reducers/envelope.js